"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    relativeTime: ()=>relativeTime,
    timeAgo: ()=>timeAgo
});
const index_js_namespaceObject = require("../locale/index.js");
const intervalMap = {
    year: 31536000,
    month: 2592000,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1
};
const cnLocale = {
    year: "\u5E74",
    month: "\u4E2A\u6708",
    day: "\u5929",
    hour: "\u5C0F\u65F6",
    minute: "\u5206\u949F",
    second: "\u79D2",
    justNow: "\u521A\u521A",
    ago: "\u524D",
    later: "\u540E"
};
const enLocale = {
    year: 'year',
    month: 'month',
    day: 'day',
    hour: 'hour',
    minute: 'min',
    second: 'second',
    justNow: 'Just now',
    ago: ' ago',
    later: ' later'
};
const getTimeLocale = (count, unit, locale)=>{
    if ('zh' === locale) return cnLocale[unit];
    const complexArray = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second'
    ];
    if (1 === count || !complexArray.includes(unit)) return enLocale[unit];
    return `${enLocale[unit]}s`;
};
const compareTime = (timea, timeb)=>{
    const seconds = Math.abs(Math.floor((timea - timeb) / 1000));
    const getResult = (unit)=>({
            count: Math.floor(seconds / intervalMap[unit]),
            unit
        });
    if (seconds >= intervalMap.year) return getResult('year');
    if (seconds >= intervalMap.month) return getResult('month');
    if (seconds >= intervalMap.day) return getResult('day');
    if (seconds >= intervalMap.hour) return getResult('hour');
    if (seconds >= intervalMap.minute) return getResult('minute');
    else return getResult('second');
};
const timeAgo = function(date) {
    let locale = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : index_js_namespaceObject.defaultCloudLocale;
    const time = 'number' == typeof date ? date : new Date(date).getTime();
    const current = Date.now();
    const localePack = 'en' === locale ? enLocale : cnLocale;
    if (current < time) return localePack.justNow;
    const compared = compareTime(current, time);
    if (0 === compared.count) return localePack.justNow;
    return `${compared.count} ${getTimeLocale(compared.count, compared.unit, locale)}${localePack.ago}`;
};
const relativeTime = function(date) {
    let locale = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : index_js_namespaceObject.defaultCloudLocale;
    const time = 'number' == typeof date ? date : new Date(date).getTime();
    const current = Date.now();
    const localePack = 'en' === locale ? enLocale : cnLocale;
    const isFuture = time > current;
    const compared = compareTime(current, time);
    if (0 === compared.count) return localePack.justNow;
    return `${compared.count} ${getTimeLocale(compared.count, compared.unit, locale)}${isFuture ? localePack.later : localePack.ago}`;
};
exports.relativeTime = __webpack_exports__.relativeTime;
exports.timeAgo = __webpack_exports__.timeAgo;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "relativeTime",
    "timeAgo"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
